// extracted by mini-css-extract-plugin
module.exports = {"centeredForm":"app-form_centeredForm__2AjJ5","profileForm":"app-form_profileForm__2gDfq","title":"app-form_title__1PPyZ pb-6 text text_type_main-medium"};